import webApi, { baseURL } from "../../WebApi/WebApi";

export const getSuppliersList = async (data) => {
  return await webApi.get(
    `/customer/supplier/list-supplier?searchKeyword=`,
    {}
  );
};

export const getSupplierById = async (data) => {
  console.log(data, "datata");
  return await webApi.post(`/customer/supplier/get-supplier-by-id`, {
    supplierId: Number(data),
  });
};

// export const getAllSupplierInvoicelist = async (business, supplier, data, from, to) => {
//     console.log(data, business, supplier, "sdsdsd")
//     return await webApi.post(`/customer/supplier/get-invoices-by-supplier-id`,
//         {
//             "supplierId":49,
//             "fromDate":"2023-10-05",
//             "toDate":"2023-10-07",
//             "businessUnitName":["Þrúðvangur Þorgfj."]
//         });
// }

//product by supplier
export const getAllInvoiceSupplierInvoicelist = async (
  supplierId,
  business,
  from,
  to
) => {
  return await webApi.post(`/customer/supplier/get-invoices-by-supplier-id`, {
    supplierId: Number(supplierId),
    fromDate: from ? from : "",
    toDate: to ? to : "",
    businessUnitName: business ? business : [],
  });
};

//order by supplier
export const getAllOrderSupplierInvoicelist = async (
  supplierId,
  business,
  from,
  to
) => {
  return await webApi.post(`/customer/supplier/get-orders-by-supplier-id`, {
    supplierId: Number(supplierId),
    fromDate: from ? from : "",
    toDate: to ? to : "",
    businessUnitName: business ? [business] : [],
  });
};

//order by supplier
export const getAllProductsSupplierlist = async (
  supplierId,
  isVatPasent,
  month,
  isToggleddata = false
) => {
  return await webApi.post(`/customer/supplier/get-products-by-supplier-id`, {
    supplierId: Number(supplierId),
    isVatPasent: isVatPasent ? isVatPasent : "",
    month: month ? month : "",
    isToggleddata,
  });
};

export const getActiveSupplier = async (
  module,
  id,
  isactive,
  onSuccess,
  onFailure
) => {
  try {
    const res = await webApi.post(`/customer/common/is-active`, {
      module: module,
      id: id,
      isActive: isactive,
    });
    if (res.status === 200) {
      const r = res.data;
      return onSuccess(r);
    } else {
      onFailure("Something Wrong! Please Try again later" + res.data);
    }
  } catch (error) {
    console.log("fdgdf");
  }
};

export const addSupplier = async (data, onSuccess, onFailure) => {
  try {
    const res = await webApi.post(`/customer/supplier/add-supplier`, data);
    if (res.status === 200) {
      const r = res.data;
      return onSuccess(r);
    } else {
      onFailure("Something Wrong! Please Try again later" + res.data);
    }
  } catch (error) {
    console.log("fdgdf");
  }
};

export const masterListSupplier = async (
  searchKeyword,
  onSuccess,
  onFailure
) => {
  try {
    const res = await webApi.get(
      `/customer/supplier/master-list-supplier?searchKeyword=${searchKeyword}`
    );
    if (res.status === 200) {
      const r = res.data;
      return onSuccess(r);
    } else {
      onFailure("Something Wrong! Please Try again later" + res.data);
    }
  } catch (error) {
    console.log(error);
  }
};
